import React from "react";
import "./DropdownMenu.scss";

function DropdownMenu({ top, right, children }) {
  return (
    <div
      className="dropdown-wrapper"
      style={{
        top: `${top}px`,
        right: `${right}px`,
      }}
    >
      <div className="dropdown-content-wrapper">{children}</div>
    </div>
  );
}

export default DropdownMenu;
